import { setLoading, addAlert } from "src/modules/notification/redux";
import {
  adminCreateTicket,
  acknowledgeTicket,
  assignTicket,
  escalateTicket,
  updateTicketStatus,
  updateTicketPriority,
  addComment,
  uploadAttachment,
  updateSlaConfig,
  updateGlobalSlaConfig,
  updateBusinessHours,
  createHoliday,
  updateHoliday,
  deleteHoliday,
  updateAutoReply,
} from "../action";

const assignTicketMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { payload, type } = action;
    switch (type) {
      case assignTicket.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Ticket assigned successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const updateTicketStatusMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case updateTicketStatus.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Ticket status updated successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const updateTicketPriorityMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case updateTicketPriority.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Ticket priority updated successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const addCommentMiddleware =
  () =>
  (next) =>
  (action) => {
    next(action);
    // Optimistic message UX: no toast on success or failure. Status is
    // conveyed in-line on the message bubble (clock -> tick, or retry
    // icon on failure) by sendAdminComment in the action layer.
  };

const uploadAttachmentMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case uploadAttachment.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Attachment uploaded successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const updateSlaConfigMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case updateSlaConfig.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "SLA configuration updated successfully",
          })
        );
        break;
      case updateSlaConfig.rejected.type:
        dispatch(
          addAlert({
            severity: "error",
            message: "Failed to update SLA configuration",
          })
        );
        break;
      default:
        break;
    }
  };

const adminCreateTicketMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case adminCreateTicket.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Ticket created successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const acknowledgeTicketMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case acknowledgeTicket.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Ticket acknowledged successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const escalateTicketMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case escalateTicket.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Ticket escalated successfully",
          })
        );
        break;
      default:
        break;
    }
  };

const updateGlobalSlaConfigMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case updateGlobalSlaConfig.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Global SLA configuration updated successfully",
          })
        );
        break;
      case updateGlobalSlaConfig.rejected.type:
        dispatch(
          addAlert({
            severity: "error",
            message: "Failed to update global SLA configuration",
          })
        );
        break;
      default:
        break;
    }
  };

const updateBusinessHoursMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case updateBusinessHours.fulfilled.type:
        dispatch(
          addAlert({
            severity: "success",
            message: "Business hours updated successfully",
          })
        );
        break;
      case updateBusinessHours.rejected.type:
        dispatch(
          addAlert({
            severity: "error",
            message: "Failed to update business hours",
          })
        );
        break;
      default:
        break;
    }
  };

const updateAutoReplyMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    switch (type) {
      case updateAutoReply.fulfilled.type:
        dispatch(addAlert({ severity: "success", message: "Auto-reply message updated" }));
        break;
      case updateAutoReply.rejected.type:
        dispatch(addAlert({ severity: "error", message: "Failed to update auto-reply message" }));
        break;
      default:
        break;
    }
  };

const holidayCrudMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    const { type } = action;
    const alerts = {
      [createHoliday.fulfilled.type]: { severity: "success", message: "Holiday added" },
      [createHoliday.rejected.type]: { severity: "error", message: "Failed to add holiday" },
      [updateHoliday.fulfilled.type]: { severity: "success", message: "Holiday updated" },
      [updateHoliday.rejected.type]: { severity: "error", message: "Failed to update holiday" },
      [deleteHoliday.fulfilled.type]: { severity: "success", message: "Holiday removed" },
      [deleteHoliday.rejected.type]: { severity: "error", message: "Failed to remove holiday" },
    };
    if (alerts[type]) dispatch(addAlert(alerts[type]));
  };

export default [
  adminCreateTicketMiddleware,
  acknowledgeTicketMiddleware,
  assignTicketMiddleware,
  escalateTicketMiddleware,
  updateTicketStatusMiddleware,
  updateTicketPriorityMiddleware,
  addCommentMiddleware,
  uploadAttachmentMiddleware,
  updateSlaConfigMiddleware,
  updateGlobalSlaConfigMiddleware,
  updateBusinessHoursMiddleware,
  holidayCrudMiddleware,
  updateAutoReplyMiddleware,
];
